var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.75 10.938v4.374H6.562v6.563a6.562 6.562 0 0 0 6.563 6.563H26.25a2.187 2.187 0 1 1 0 4.375H13.125c-6.04 0-10.938-4.897-10.938-10.938V10.937H8.75Zm13.125-8.75c6.04 0 10.938 4.896 10.938 10.937v10.938H26.25v-4.375h2.188v-6.563a6.562 6.562 0 0 0-6.563-6.563H8.75a2.188 2.188 0 0 1 0-4.375h13.125Zm-5.016 9.39 4.375 4.375c.854.855.854 2.24 0 3.094l-4.375 4.375a2.188 2.188 0 0 1-3.093-3.094l2.828-2.828-2.828-2.828a2.187 2.187 0 1 1 3.093-3.094Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4ce939662417ecc33563b5b97b1b3a68.svg";
export { ForwardRef as ReactComponent };